<template>
  <el-dialog :visible="visible"
    :append-to-body="true"
    :showClose="true"
    title="Edit Tags"
    @close="close">
    <el-form :model="tagsCopy" v-if="filters && isShow">
      <div class="mx-24 mt-16">
        <el-row
          :gutter="16"
          class="mt-8"
        >
          <el-col v-if="carOrientation" :span="12">
            <el-form-item prop="car_orientation">
              <el-select
                :label="carOrientation.item_label || 'Car Orientation'"
                placeholder=''
                filterable
                :value="tagsCopy.car_orientation"
                @change="changeTagHandler($event, 'car_orientation')"
              >
                <el-option
                  v-for="option in carOrientation.filter_values"
                  :key="option.value"
                  :label="option.label"
                  :value="option.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="12">
            <el-form-item prop="car_number">
              <el-select
                :label="filters.left_filters[0].item_label"
                placeholder=''
                filterable
                :value="tagsCopy.car_number"
                @change="changeTagHandler($event, 'car_number')"
              >
                <el-option
                  v-for="option in filters.left_filters[0].filter_values"
                  :key="option.value"
                  :label="option.label"
                  :value="option.value"
                />
              </el-select>
              <el-input
                :label="filters.left_filters[0].item_label"
                placeholder=''
                :value="tagsCopy.car_number"
                @change="changeTagHandler($event, 'car_number')"
                />
            </el-form-item>
          </el-col> -->
          <el-col v-if="trackSector" :span="12">
            <el-form-item prop="track_sector">
              <el-select
                filterable
                placeholder=''
                :label="trackSector.item_label || 'Track sector'"
                :value="tagsCopy.track_sector"
                @change="changeTagHandler($event, 'track_sector')"
              >
                <el-option
                  v-for="option in trackSector.filter_values"
                  :key="option.value"
                  :label="option.label"
                  :value="option.value"
                />
              </el-select>
            </el-form-item>
          </el-col>

          <el-col v-if="carModel" :span="24">
            <el-form-item prop="car_model">
              <el-select
                :label="carModel.item_label || 'Car Model'"
                placeholder=''
                filterable
                :value="tagsCopy.car_model"
                @change="changeTagHandler($event, 'car_model')"
              >
                <el-option
                  v-for="option in carModel.filter_values"
                  :key="option.value"
                  :label="option.label"
                  :value="option.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
      <el-divider/>
    </el-form>
    <el-spinner v-else color="white"/>
    <div class="dialog-footer-wrapper pt-8">
      <el-button @click="submit">Submit</el-button>
      <el-button @click="close">Cancel</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getRaceImagesFilters } from '../../api/raceimages'

export default {
  name: 'EditTagsDialog',
  props: {
    tags: {
      type: Object,
      required: true
    },
    visible: {
      type: Boolean,
      required: true
    },
    raceId: {
      type: String,
      required: true
    },
  },
  data() {
    return {
      filters: null,
      newTags: {},
      tagsCopy: {},
      isShow: true
    }
  },
  computed: {
    allFilters() {
      return Object.values(this.filters)?.flat();
    },
    allFiltersFormated() {
      if (!this.allFilters) {
        return [];
      }

      return this.allFilters.reduce((res, cur) => {
        res[cur.filter_var] = cur;
        return res;
      }, {});
    },
    carModel() {
      return this.allFiltersFormated?.car_model || null;
    },
    carOrientation() {
      return this.allFiltersFormated?.car_orientation || null;
    },
    trackSector() {
      return this.allFiltersFormated?.track_sector || null;
    },
  },
  methods: {
    close() {
      this.$emit('close')
    },
    submit() {
      this.$emit('submit', this.newTags)
    },
    changeTagHandler(event, tagKey) {
      if (this.tags[tagKey] !== event && event) {
        this.newTags[tagKey] = event
        this.tagsCopy[tagKey] = event
        this.isShow = false
        this.$nextTick(() => this.isShow = true)
      }
    },
  },
  watch: {
    tags() {
      for (let key in this.tags) {
        this.tagsCopy[key] = this.tags[key]
      }
    }
  },
  mounted() {
    getRaceImagesFilters(this.raceId, {...this.selectedFilters})
      .then(res => {
        this.filters = res.data.filter
        return res
      })
  }
}
</script>

<style lang="scss" scoped>
.dialog-input-wrapper {
  padding: 16px;
}
.dialog-footer-wrapper {
  padding: 0 16px 16px 16px;
}
</style>
